import(/* webpackMode: "eager", webpackExports: ["BasketTable"] */ "/builds/webdev/customer-projects/lachner-fe/eshop/components/ProductDetail/BasketTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/eshop/components/ProductDetail/BreadCrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopProductDetailInfo","BottomProductDetailInfo"] */ "/builds/webdev/customer-projects/lachner-fe/eshop/components/ProductDetail/Info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/eshop/components/ProductDetail/ProductImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/eshop/components/ProductDetail/Safety.tsx");
